import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root'
})
export class MasterPerfilAcessoService {
  
  constructor( private http: HttpClient ) { }

  getProfileSearch(name) {
    return this
        .http
        .get<any>(`${BASE_PATH}/bff/master/clients/profiles?name=${name}`)
        .toPromise();
  }

  getIds(ids) {
    
    const payload = [{ids}];
    

     return this
      .http
      .post<any>(`${BASE_PATH}/bff/master-bo/users/create/profile/profiles/list`, payload)
      .toPromise();
  }

}